export class Report {
    reportName: string;
    reportType: string;
    reportTypeLabel: string;
    reportData: ReportData = new ReportData();

    constructor() {
    }
    
    clear() {
        this.reportData = new ReportData();
        this.reportName = '';
        
        // this.reportType = '';
        // this.reportTypeLabel = '';

    }
}

export class ReportData {
    blockList: string[];
    lrnList: string[];
    startDate: any;
    endDate: any;
    regionList: string[];
    spidList: string[];
    portActivityList: string[];
    fromDate: any;
    toDate: any;
    dateType: string;
  
    constructor() {
        // console.log("report data constructor");
      this.regionList = [];
      this.spidList = [];
      this.portActivityList = [];
      
    }
        
}


export class ReportForm {
    reportNameValid: boolean = true;
    portDatesInvalid: boolean = false;
    report = new Report()
  
    reset() {
        this.report.clear();
        this.reportNameValid = true;
        this.portDatesInvalid = false;

    }
  }




